import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import TicketStageTracker, { PRIORITY_STYLE } from './TicketStageTracker';

// One ticket: number, problem, source, priority, the 4-stage tracker, engineer and visit date. Actions go in children.
export default function TicketCard({ ticket: t, children, highlight }) {
    return (
        <Box sx={{ border: '1px solid', borderColor: highlight ? '#99d5cf' : '#e5e9ee', borderRadius: 3, p: 1.5, mb: 1.25, bgcolor: '#fff' }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ fontSize: '11.5px', color: '#6b7785' }}>
                        {t.id} · {t.source} · raised {dayjs(t.created_at).format('D MMM YYYY')}{t.raised_by_name ? ` by ${t.raised_by_name}` : ''}
                    </Typography>
                    <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>{t.title}</Typography>
                    {t.description && t.description !== t.title && <Typography sx={{ fontSize: '12.5px', color: '#46525e', mt: 0.25, whiteSpace: 'pre-line' }}>{t.description}</Typography>}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5, flex: 'none' }}>
                    {t.priority && <Chip size="small" label={t.priority} sx={{ height: 20, fontSize: '11px', fontWeight: 700, ...PRIORITY_STYLE[t.priority] }} />}
                    {t.equipment && <Chip size="small" variant="outlined" label={t.equipment} sx={{ height: 20, fontSize: '11px' }} />}
                </Box>
            </Box>
            <TicketStageTracker stage={t.stage} />
            <Typography sx={{ fontSize: '12.5px', color: '#6b7785', mt: 1 }}>
                {t.engineer ? `👷 ${t.engineer.name}` : 'No engineer yet'}
                {t.scheduled_date ? ` · 📅 visit ${dayjs(t.scheduled_date).format('ddd D MMM YYYY')}` : ''}
                {t.stage === 'resolved' && t.closed_at ? ` · resolved ${dayjs(t.closed_at).format('D MMM YYYY')}` : ''}
                {!t.assignable && ' · managed in Zoho (read-only here)'}
            </Typography>
            {t.resolution_note && <Typography sx={{ fontSize: '12.5px', mt: 0.5 }}><b>Resolution:</b> {t.resolution_note}</Typography>}
            {children}
        </Box>
    );
}
